<template>
    <div>
        <Row :gutter="16">
            <Col span="18">
                <Card>
                    <p slot="title">{{t.routerName}}</p>
                    <Row :gutter="16">
                        <Col span="24">
                            <Form :model="formItem" :rules="ruleValidate" :label-width="100" label-position="right"
                                  :loading="loading" ref="form">
                                <FormItem :label="t.role.name" prop="name">
                                    <Input v-model="formItem.name" :maxlength="32"
                                           :placeholder="msgUtil.placeholderRequired(t.role.name)"></Input>
                                </FormItem>
                                <FormItem :label="t.role.code" prop="code">
                                    <Input v-model="formItem.code" :maxlength="32"
                                           :placeholder="msgUtil.placeholderRequired(t.role.code)"></Input>
                                </FormItem>
                                <FormItem :label="t.role.sortOrder" prop="sortOrder">
                                    <InputNumber v-model="formItem.sortOrder" :max="9999" :min="0"></InputNumber>
                                </FormItem>
                                <FormItem :label="t.role.status" prop="status">
                                    <i-switch v-model="formItem.status" size="large" true-value="1" false-value="0">
                                        <span slot="open">{{t.role.open}}</span>
                                        <span slot="close">{{t.role.close}}</span>
                                    </i-switch>
                                </FormItem>
                                <FormItem :label="t.role.remark" prop="remark">
                                    <Input v-model="formItem.remark" :maxlength="200"
                                           :placeholder="msgUtil.placeholderRequired(t.role.remark)"
                                           type="textarea"></Input>
                                </FormItem>
                                <FormItem>
                                    <Button type="primary" :loading="loading" @click="handleSubmit()">
                                        {{msgUtil.message.action.submit}}
                                    </Button>
                                    <Button @click="handleReset()" style="margin-left: 8px">
                                        {{msgUtil.message.action.reset}}
                                    </Button>
                                </FormItem>
                            </Form>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <Col span="6">
                <Card>
                    <p slot="title">
                        <Icon type="logo-buffer"/>
                        {{t.menu.menuDistribute}}
                    </p>
                    <P style="padding-left:20px;height: 360px;overflow-x: auto;">
                        <Tree ref="tree" show-checkbox :data="menuList"></Tree>
                    </P>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
import { getTreeMenuList } from '@/api/menu';
import { add, getRoleInfo } from '@/api/role';

export default {
    name: 'organization_role_add',
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            formItem: {
                name: '',
                status: '1',
                code: '',
                sortOrder: 0,
                menuIdList: [],
                remark: '',
            },
            //所有的后台权限菜单列
            menuList: [],
            loading: false,
            ruleValidate: {
                name: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.role.name),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 32,
                        message: msgUtil.errorMaxLengthFullWidth(t.role.name, 32),
                        trigger: 'blur',
                    },
                ],
                authority: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.role.authority),
                        trigger: 'change',
                    },
                ],
                code: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.role.code),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 32,
                        message: msgUtil.errorMaxLengthFullWidth(t.role.code, 32),
                        trigger: 'blur',
                    },
                ],
                sortOrder: [
                    {
                        required: true,
                        type: 'number',
                        message: msgUtil.errorRequired(t.role.sortOrder),
                        trigger: 'blur',
                    },
                ],
                remark: [
                    {
                        type: 'string',
                        max: 200,
                        message: msgUtil.errorMaxLengthFullWidth(t.role.remark, 200),
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    methods: {
        handleSubmit() {
            this.loading = true;
            this.$Loading.start();
            this.$refs['form'].validate(async valid => {
                if (valid) {
                    this.loading = true;
                    this.formItem.menuIdList = this.$refs.tree.getCheckedAndIndeterminateNodes().map(p => p.id);
                    const res = await add(this.formItem);
                    this.$Message.success(this.msgUtil.message.action.addSuccess);
                    this.$refs.form.resetFields();
                    this.formItem.menuIdList = [];
                    this.$Loading.finish();
                } else {
                    this.$Loading.error();
                    this.$Message.error(this.msgUtil.message.action.addFail);
                }
            });
            this.loading = false;
        },
        handleReset() {
            this.$refs.form.resetFields();
            this.loading = false;
        },
    },
    async mounted() {
        //得到后台所有菜单展示
        const menuList = await getTreeMenuList({ division: 2 });
        this.menuList = menuList.menus;
    },
};
</script>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
